<template>
  <SearchDropdown
    :placeholder="placeholder"
    :DisplayFunction="displayFunction"
    :InitialValue="'' + (initialValue || displayFunction(item) )"
    :ObjKey="'id'"
    :width="width"
    :browseIcon="true"
		:pages="pages"
    :externalResults="items"
    :dropUp="dropUp"
    @selected="item => select(item)"
    @search="(txt, pg) => getItems(txt, pg)"
    @none="select(null)"
    ref="search"
  />
</template>


<script>
import ProductsAPI from '@/api/ProductsAPI.js'
import PricingOption from '@/models/PricingOption.js'
import PaginatedRequest from '@/api/PaginatedRequest.js'
import SearchDropdown from '@/components/utilities/SearchDropdown.vue';

export default {
  name: 'PricingOptionSearchDropdown',

  components: {
    SearchDropdown,
  },

  props: {
    item: {
      type: Object,
      default: null
    },
    
    productSKU: {
      type: String,
      default: null
    },

    width: {
      type: String,
      default: '50%'
    },

    placeholder: {
      type: String,
      default: 'Search Pricing Options'
    },

    initialValue: {
      type: [String, Number],
      default: null
    },

		dropUp: {
			type: Boolean,
			default: false
		},

  },


  model: {
    prop: 'item',
    event: 'update'
  },

  data() {
    return {
      items: [],
      pages: 1,
    }
  },

  methods: {

    select(item) {
      this.$emit('update', item);
    },

    clear() { this.$refs.search.clear() },

    displayFunction( obj ) {
      if( !obj ) return '';
      var str = `${ obj.id } - ${ obj.name }:<br>${ obj.getPricingString(null, false) }${ obj.isSubscription ? ' +<br>' : '' }${ obj.getSubscriptionString(null, false)}${ obj.isSubscription ? ' / ' + obj.intervalString : ''}`
      return str
    },

    async getItems( searchTerm, page = 1 ) {
      this.items = []

      const req = new PaginatedRequest( 'name', true, page, 25, searchTerm )
      if( this.productSKU ) req.productSKU = this.productSKU

      const data = await ProductsAPI.getPricingOptions( req )

      if( !data || !data.data ) return
      this.pages = data.pages
      for( let item of data.data ) this.items.push( PricingOption.import(item) )
    },
  }


}
</script>
